var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasItems)?_c('div',{staticClass:"feed"},[_vm._t("default")],2):(_vm.allLoaded)?_c('div',{staticClass:"all-watched"},[_vm._v(" "+_vm._s(_vm.$t("all_watched"))+" ")]):_c('div',{staticClass:"spinner"},[_c('SpinnerIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }